import { setTimezone } from 'owa-service/lib/config';
import { setDateFormat, setTimeFormat, setLocalTimeZone } from 'owa-datetime-store';
import { updateSessionSettings, updateUserOptions } from 'owa-options-core';
import {
    logCurrentTimeZoneQuick,
    logDateFormatQuick,
    logTimeFormatQuick,
} from '../utils/logDataOnSaveRegionalOptions';

import hasTimeZoneChanged from '../utils/hasTimeZoneChanged';
import hasLanguageChanged from '../utils/hasLanguageChanged';
import getNewDateFormat from '../utils/getNewDateFormat';
import getNewTimeFormat from '../utils/getNewTimeFormat';
import getUserCulture from '../utils/getUserCulture';
import getNewTimeZone from '../utils/getNewTimeZone';
import localeHotReload from '../utils/localeHotReload';
import getRegionalOptionsServiceRequests from '../utils/getRegionalOptionsServiceRequests';

export default async function saveRegionalOption() {
    // Save language
    const languageHasChanged = hasLanguageChanged();
    const userCulture = getUserCulture();
    updateSessionSettings({ UserCulture: userCulture });

    // Save date format
    const newDateFormat = getNewDateFormat();
    setDateFormat(newDateFormat);

    // Save time format
    const newTimeFormat = getNewTimeFormat();
    setTimeFormat(newTimeFormat);

    // Save time zone
    const timeZoneHasChanged = hasTimeZoneChanged();
    let newTimeZone = getNewTimeZone();
    setTimezone(newTimeZone);

    // Update owa-datetime
    setLocalTimeZone(newTimeZone);

    // Save the new values to UserOptions
    updateUserOptions({
        DateFormat: newDateFormat,
        TimeFormat: newTimeFormat,
        TimeZone: newTimeZone,
    });

    const promises: Promise<any>[] = getRegionalOptionsServiceRequests(
        languageHasChanged,
        timeZoneHasChanged
    );
    await Promise.all(promises);

    localeHotReload(languageHasChanged);
}

/**
 * Saves the newTimeZone value, used in quickSettings
 */
export const saveTimeZoneSelection = async newTimeZone => {
    const timeZoneHasChanged = hasTimeZoneChanged(newTimeZone);

    // Save
    setTimezone(newTimeZone);

    // Update owa-datetime
    setLocalTimeZone(newTimeZone);

    // Update UserOptions
    updateUserOptions({
        TimeZone: newTimeZone,
    });

    const promises: Promise<any>[] = getRegionalOptionsServiceRequests(false, timeZoneHasChanged);
    await Promise.all(promises);

    logCurrentTimeZoneQuick();
};

/**
 * Saves the newDateFormat value, used in quickSettings
 */
export const saveDateFormatSelection = async newDateFormat => {
    setDateFormat(newDateFormat);

    updateUserOptions({
        DateFormat: newDateFormat,
    });

    const promises: Promise<any>[] = getRegionalOptionsServiceRequests(false, false);
    await Promise.all(promises);

    logDateFormatQuick();
};

/**
 * Saves the newTimeFormat value, used in quickSettings
 */
export const saveTimeFormatSelection = async newTimeFormat => {
    setTimeFormat(newTimeFormat);

    updateUserOptions({
        TimeFormat: newTimeFormat,
    });

    const promises: Promise<any>[] = getRegionalOptionsServiceRequests(false, false);
    await Promise.all(promises);

    logTimeFormatQuick();
};
